import { calculateDensityBaseValues } from "../../../oilPhasePVT";

function getStandingCondensateDensityLBMFT3(
  condensateSpecificGravity: number,
  gasSpecificGravity: number,
  solutionGasSCFSTB: number,
  temperatureF: number
): number {
  return (
    (condensateSpecificGravity * 62.428 +
      0.0136 * solutionGasSCFSTB * gasSpecificGravity) /
    (0.972 +
      0.000147 *
        Math.pow(
          solutionGasSCFSTB *
            Math.pow(gasSpecificGravity / condensateSpecificGravity, 0.5) +
            1.25 * temperatureF,
          1.175
        ))
  );
}

// Standing density chain off the dew point: compressed above it, plain Standing at or below
export function condensateDensityCalculator(
  condensateSpecificGravity: number,
  condensateApi: number,
  gasSpecificGravity: number,
  oilPhaseGasSolubilitySCFSTB: number,
  pressurePSIA: number,
  temperatureF: number,
  dewPointPressurePSIA: number
): number {
  const {
    solutionGasAtBubblePoint: solutionGasAtDewPoint,
    oilCompressibility: condensateCompressibility
  } = calculateDensityBaseValues({
    pressurePSIA,
    oilAPI: condensateApi,
    temperatureF,
    gasSpecificGravity,
    bubblePointPressurePSIA: dewPointPressurePSIA
  });

  const saturatedCondensateDensityLBMFT3 = getStandingCondensateDensityLBMFT3(
    condensateSpecificGravity,
    gasSpecificGravity,
    oilPhaseGasSolubilitySCFSTB,
    temperatureF
  );
  const condensateDensityAtDewPointLBMFT3 = getStandingCondensateDensityLBMFT3(
    condensateSpecificGravity,
    gasSpecificGravity,
    solutionGasAtDewPoint,
    temperatureF
  );
  const underSaturatedCondensateDensityLBMFT3 =
    condensateDensityAtDewPointLBMFT3 *
    Math.exp(condensateCompressibility * (pressurePSIA - dewPointPressurePSIA));

  const density =
    pressurePSIA > dewPointPressurePSIA
      ? underSaturatedCondensateDensityLBMFT3
      : saturatedCondensateDensityLBMFT3;

  return Number.isFinite(density) && density > 0 ? density : 0;
}
